import { useState, useEffect } from 'react';
import APIService from '../../Service/APIService';
import { message } from 'antd';

/**
 * Custom hook for fetching data with date range filters
 * 
 * @param {string} apiEndpoint - API endpoint for fetching data
 * @param {Object} initialFilters - Initial filters to apply
 * @param {Object} options - Additional options
 * @param {boolean} options.fetchOnMount - Whether to fetch data when component mounts
 * @param {Function} options.transformResponse - Function to transform the response data
 * @returns {Object} - { data, loading, error, fetchData }
 */
const useDateFilteredData = (
  apiEndpoint,
  page = 0,
  pageSize = 10,
  initialFilters = null,
  { 
    fetchOnMount = true,
    transformResponse = (data) => data,
  } = {}
) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentFilters, setCurrentFilters] = useState(initialFilters);
  const [tCount, setTCount] = useState(0);
  const [tPages, setTPages] = useState(0);

  const fetchData = async (filters = null) => {
    setLoading(true);
    setError(null);
    
    try {
      let url = apiEndpoint;
      
      // Apply filters if provided
      if (filters) {
        const params = new URLSearchParams();
        
        if (filters.startDate) {
          params.append('startDate', filters.startDate);
        }
        
        if (filters.endDate) {
          params.append('endDate', filters.endDate);
        }

        params.append('page', page);
        params.append('pageSize', pageSize);
        
        // Add any additional filters
        Object.entries(filters).forEach(([key, value]) => {
          if (key !== 'startDate' && key !== 'endDate' && value !== undefined && value !== null) {
            params.append(key, value);
          }
        });
        
        if (params.toString()) {
          url = `${apiEndpoint}?${params.toString()}`;
        }
      }
      
    //   const response = await axios.get(url);
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(url);
      console.log("Response from backend: ", response);
      const transformedData = transformResponse(response.data.data);
      setData(transformedData);
      setTCount(response?.data?.totalCount ? response.data.totalCount : response.data?.data?.length);
      setTPages(response.data?.totalPages ? response.data?.totalPages : Math.ceil((response.data?.data?.length)/10));
      setCurrentFilters(filters);
      
      return transformedData;
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err);
      message.error('Failed to fetch data. Please try again.');
      return [];
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on mount if enabled
  useEffect(() => {
    if (fetchOnMount) {
      fetchData(initialFilters);
    }
  }, []);

  return {
    data,
    loader: loading,
    error,
    fetchData,
    currentFilters,
    tCount,
    tPages
  };
};

export default useDateFilteredData;